










import { defineComponent } from '@vue/composition-api'

/**
 * リンクボタン(a)を表示するAtomコンポーネント。
 */
export default defineComponent({
  name: 'AtomRouterButton',
  props: {
    /**
     * リンクの文字
     */
    linkText: {
      type: String,
      required: true,
    },
    /**
     * リンクしたいURL
     */
    to: {
      type: String,
      required: true,
    },
    /**
     * テーマカラー指定
     */
    theme: {
      type: String,
      default: 'light',
    },
    /**
     * カラー指定
     */
    colorType: {
      type: String,
      default: 'primary',
    },
    /**
     * サイズ指定
     */
    size: {
      type: String,
      default: 'large',
    },
  },
})
